import { useState, useRef, useCallback, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClickOutside } from '@petseo/shared';
import { useProfileStore } from '@/store';
import { ProfileSelectorContext } from '@/contexts/ProfileSelectorContext';
import type { ServiceVendorId } from '@/services/api/petseo.client.wrapper';

interface ProfileSelectorProps {
  children: ReactNode;
}

export function ProfileSelector({ children }: ProfileSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const setSelectedProfileId = useProfileStore((s) => s.setSelectedProfileId);
  const navigate = useNavigate();

  useClickOutside(
    dropdownRef,
    useCallback(() => setIsOpen(false), []),
    isOpen
  );

  const handleSelectProfile = useCallback(
    (id: ServiceVendorId) => {
      setSelectedProfileId(id);
      setIsOpen(false);
      navigate('/');
    },
    [setSelectedProfileId, navigate]
  );

  return (
    <ProfileSelectorContext.Provider
      value={{
        isOpen,
        setIsOpen,
        onSelectProfile: handleSelectProfile,
      }}>
      <div ref={dropdownRef} className="dropdown" style={{ position: 'relative' }}>
        {children}
      </div>
    </ProfileSelectorContext.Provider>
  );
}
